import * as firebase from 'firebase'





// Get a Firestore instance
var config = { 
    apiKey: "AIzaSyCrqVMHoc5kZzXslr3lvqT5LQ9YPN6cHmY",
    authDomain: "websiteincubefzco.firebaseapp.com",
    projectId: "websiteincubefzco",
    storageBucket: "websiteincubefzco.appspot.com",
    messagingSenderId: "1006497790240",
    appId: "1:1006497790240:web:2c6858dce5746b4f1eff45"
};


export const fb = firebase.initializeApp(config)

export const db = firebase.firestore()

export const userAuth = null






// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
// const { TimeStamp, GeoPoint } = firebase.firestore()
// export { TimeStamp, GeoPoint }
